import Template from "@/src/components/templates/Users/UsersOverviewTemplate";

const UsersOverview = () => <Template />;

export default UsersOverview;
